import React, { useEffect, useRef, useState } from 'react';
import { 
    Box,
    Button,
    CircularProgress,
    ClickAwayListener,
    Fade,
    Popper,
    Typography
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ClearIcon from '@mui/icons-material/Clear';
import { useAuth0 } from "@auth0/auth0-react";
import VideoFileIcon from '@mui/icons-material/VideoFile';

import ItemList from '../menuitem/ItemList';
import SecondaryButton from '../buttons/SecondaryButton';
import customTheme from '../../theme';
import {useFetch} from '../../components/auth/useFetch';


export default function UploadIllusionMobile(props) {

    const { fileBrowserRef } = props
    const fetchWithAuth = useFetch()

    
    const onFileSelect = (event) => {
        uploadEDL(event.target.files[0])

    }

    const uploadEDL = async (file) => {
        var formdata = new FormData();
        formdata.append("file_upload", file);
        var requestOptions = {
            method: 'POST',
            body: formdata,
            redirect: 'follow'
        }
        fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/illusionstormupload/`, requestOptions)
    }

    return (
        <input
            type='file'
            id='file'
            ref={fileBrowserRef}
            style={{display: 'none'}}
            onChange={onFileSelect}
        />
    )}